/**
 * Represents a storage candidate passed into storage capability checks.
 */
export interface StorageSupportCheckInput {
  storage: Storage | undefined;
}

/**
 * Validates that a storage-like object exposes the minimum Storage API used here.
 */
export function hasStorageApi(
  input: StorageSupportCheckInput,
): input is StorageSupportCheckInput & { storage: Storage } {
  return Boolean(
    input.storage &&
      typeof input.storage.getItem === "function" &&
      typeof input.storage.setItem === "function" &&
      typeof input.storage.removeItem === "function" &&
      typeof input.storage.key === "function",
  );
}
